import React from 'react';

export const formatEmailLink = (email: string | null | undefined) => {
    if (!email) return '';

    return (
        <a
            href={`mailto:${email}`}
            style={{ color: '#1a73e8', textDecoration: 'none' }}
            onMouseEnter={(e) => (e.currentTarget.style.textDecoration = 'underline')}
            onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')}
        >
            {email}
        </a>
    );
};
